import { removeDupes } from '../utils/helpers';

const users = (state = {
    items: [],
    currentUserId: null,
    currentUserFetched: false,
    currentUserLoading: true,
    teamUsersFetched: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                items: [],
                currentUserId: null,
                currentUserFetched: false,
                currentUserLoading: true
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(user => ({
                    ...user,
                    shouldRefetch: true
                }))]
            });

        case 'CURRENT_USER_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: removeDupes([action.payload.user, ...state.items]),
                currentUserId: action.payload.user.id,
                currentUserFetched: true,
                currentUserLoading: false
            });

        case 'USER_FETCH_REQUESTED': 
            return Object.assign({}, state, {
                items: [...state.items, {
                    ...(state.items.find(user => user.id === action.payload.userId) || {}),
                    id: action.payload.userId,
                    loading: true
                }]
            });

        case 'USER_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === action.payload.userId) {
                        return {
                            id: action.payload.userId,
                            removed: true
                        }
                    }

                    return user;
                })
            });

        case 'USER_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === action.payload.userId) {
                        return action.payload.user;
                    }

                    return user;
                })
            });

        case 'USERS_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: removeDupes([...state.items, ...action.payload.users]),
                teamUsersFetched: true
            });

        case 'USER_UPDATE_ONLINE_STATUS_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === action.payload.userId) {
                        return Object.assign({}, user, { online: action.payload.online });
                    }

                    return user;
                })
            });

        case 'USER_UPDATE_REQUESTED':
        case 'USER_UPDATE_SOCKET':
        case 'CURRENT_USER_UPDATE_EMAIL_REQUESTED':
        case 'CURRENT_USER_UPDATE_REQUESTED': {
            const userProps = {...(action.payload.user || action.payload.userProps)};
            const userId = ['CURRENT_USER_UPDATE_REQUESTED', 'CURRENT_USER_UPDATE_EMAIL_REQUESTED'].includes(action.type) ? state.currentUserId : action.payload.userId;

            if (userProps.avatarBase64) {
                userProps.avatar = userProps.avatarBase64;
                userProps.avatarBase64 = undefined;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === userId) {
                        return Object.assign({}, user, {
                            ...userProps,
                            tours: userProps.tour_passed ? [...(user.tours || []), userProps.tour_passed] : user.tours
                        });
                    }

                    return user;
                })
            });
        }

        case 'USER_SSO_LINK_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === state.currentUserId) {
                        return Object.assign({}, user, {
                            authData: {
                                google: {}
                            }
                        });
                    }

                    return user;
                })
            });

        case 'USER_SSO_UNLINK_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === state.currentUserId) {
                        return Object.assign({}, user, {
                            authData: null
                        });
                    }

                    return user;
                })
            });

        case 'USER_INVITE_ACCEPT_SOCKET':
            if (!state.items.some(user => user.id === action.payload.userId)) {
                return Object.assign({}, state, {
                    items: [action.payload.user, ...state.items]
                });
            }

            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === action.payload.userId) {
                        return Object.assign({}, user, { pending: false })
                    }

                    return user;
                })
            });

        case 'USER_INVITE_CANCEL_SOCKET':
        case 'USER_REMOVE_REQUESTED':
        case 'TEAM_USER_REMOVE_SOCKET':
            if (action.payload.projectId || action.payload.projectsOnly) {
                return state;
            }

            return Object.assign({}, state, {
                items: state.items.map(user => {
                    if (user.id === action.payload.userId) {
                        return {
                            ...user,
                            removed: true
                        }
                    }

                    return user;
                })
            });

        case 'USER_UPDATE_ROLE_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(user => {
                    if (user.id === action.payload.userId) {
                        return Object.assign({}, user, { role: action.payload.role })
                    }

                    return user;
                })
            });

        default:
            return state;
    }
}

export default users;
